import React from 'react';
import { classes } from './UnavailableSlotMessage.st.css';
import {
  SectionMessage,
  SectionMessageType,
} from '../SectionMessage/SectionMessage';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { UnavailableSlotMessageDataHooks } from './dataHooks';
import { useFormActions } from '../../Hooks/useFormActions';

export const UnavailableSlotMessage: React.FC = () => {
  const { t } = useTranslation();
  const { navigateToCalendarPage } = useFormActions();

  return (
    <SectionMessage
      type={SectionMessageType.Error}
      text={t('app.bookings-form.slot-unavailable.notification')}
      className={classes.root}
      dataHook={UnavailableSlotMessageDataHooks.NOTIFICATION_MESSAGE}
      buttonText={t('app.bookings-form.slot-unavailable.cta')}
      buttonOnClick={() => navigateToCalendarPage()}
    />
  );
};
